import React from 'react';
import PropTypes from 'prop-types';
import './TableRow.scss';

const TableRow = ({ book, writtenComp, onBookTitleClick, additionalClasses }) => {
    const { actualScore, bookTitle, genre, accuracy, assessmentMode, readingComp, performance } =
        book;
    const bookCellClassName = 'book-cell';

    return (
        <div className={`table-row ${additionalClasses}`}>
            <div className={`${bookCellClassName} book-level-title`}>
                <div className="book-level">{actualScore}</div>
                <div className="book-name" onClick={onBookTitleClick} role="presentation">
                    {bookTitle}
                </div>
            </div>
            <div className={`${bookCellClassName} book-performance`}>{performance}</div>
            <div className={`${bookCellClassName} book-genre`}>{genre}</div>
            <div className={`${bookCellClassName} book-reading-accuracy display-book-content`}>
                {accuracy}
            </div>
            <div className={`${bookCellClassName} book-reading-comp display-book-content`}>
                {readingComp}
            </div>
            {writtenComp}
            <div className={`${bookCellClassName} book-assessment-mode`}>{assessmentMode}</div>
        </div>
    );
};

TableRow.defaultProps = {
    book: {},
    writtenComp: <></>,
    additionalClasses: '',
    onBookTitleClick: () => {},
};

TableRow.propTypes = {
    book: PropTypes.object,
    writtenComp: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    additionalClasses: PropTypes.string,
    onBookTitleClick: PropTypes.func,
};

export default TableRow;
